import React from 'react';
import { AppDownloadChooser } from './AppDownloadChooser';

/** Post-checkout welcome shown at the top of /get-the-app. Content only. */
export function FoundingMemberWelcome() {
  return <section aria-labelledby="welcome-heading" className="max-w-7xl mx-auto px-6 md:px-12 pt-10 md:pt-16 pb-16 md:pb-24" data-id="element-406" data-mp="2ojyamecowwvx">
      <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_26rem] lg:gap-14 lg:items-center" data-id="element-407" data-mp="2jmpmzy8rw0na">
        <div className="rounded-[2rem] bg-purple-800 px-7 py-12 md:px-14 md:py-16" data-id="element-408" data-mp="3ga44zzu2s5nf">
          <h1 id="welcome-heading" className="font-serif text-4xl md:text-6xl text-white leading-[1.05] tracking-tight" data-id="element-409" data-mp="3cavagsr7o3qt">
            Welcome to Fem Entity 💗
          </h1>
          <p className="mt-6 font-serif text-xl md:text-2xl text-white leading-snug" data-id="element-410" data-mp="32j7ov8hc5gx9">
            You’re now a Founding Member of Canada’s national women’s health network.
          </p>
          <p className="mt-4 text-lg text-purple-100 font-light" data-id="element-411" data-mp="3v7n0rm567j4d">Your first two months are complimentary.</p>

          <div className="mt-10 border-t border-white/15 pt-8" data-id="element-412" data-mp="3hoo0vjju4o45">
            <p className="text-base md:text-lg text-white leading-relaxed" data-id="element-413" data-mp="3mm68n6m48xak">
              <strong className="font-semibold" data-id="element-414" data-mp="3moacjok0lwau">Your next step:</strong> Download the Fem Entity app and sign in with
              the account you just created to complete your practitioner profile and verification.
            </p>
          </div>
        </div>

        <AppDownloadChooser hideDescription data-id="element-415" data-mp="2yw3odcog0vmi" />
      </div>
    </section>;
}